import { Link } from 'react-router-dom';

/**
 * Sesión finalizada (pantalla 26 del prototipo v5, D-09 · RN-046c, RN-046d).
 *
 * Es lo que ve la persona en SU dispositivo cuando la sesión se corta a media
 * faena porque su acceso fue desactivado. El texto y el ícono son
 * deliberadamente neutros: no se muestra código de error ni se nombra a quien
 * ejecutó la desactivación.
 */
export default function SesionFinalizada() {
  return (
    <div className="centrado">
      <div style={{ textAlign: 'center', fontSize: 44, marginTop: 24 }} aria-hidden="true">◌</div>

      <h1 style={{ fontSize: 20, textAlign: 'center', marginBottom: 4 }}>Tu sesión terminó</h1>
      <p className="ayuda" style={{ textAlign: 'center', marginTop: 0 }}>
        Tu acceso está desactivado. Pídele a la otra persona del hogar que lo reactive.
      </p>

      {/* Fila 15 del inventario del incremento 15 (RF-222): salió la justificación de la
          implementación («las escrituras se rechazan completas»). */}
      <div className="aviso w" data-prueba="sesion-finalizada-no-guardado">
        <b>Lo que estabas escribiendo no se guardó.</b> Nada quedó a medias.
      </div>

      <div className="aviso i">
        Cuando reactiven tu acceso tendrás que iniciar sesión de nuevo: reactivar no devuelve las
        sesiones cerradas.
      </div>

      <Link className="btn ancho" to="/acceso">Ir a iniciar sesión</Link>

      {/* Fila 16 del inventario del incremento 15 (RF-223): salió la jerga técnica
          («no es dato de negocio»). */}
      <div className="info" data-prueba="sesion-finalizada-tema">
        Tu preferencia de tema en este dispositivo se conserva.
      </div>
    </div>
  );
}
